import { invokeHttp } from './api'

export const preparecreate = (patientId, service) =>
  invokeHttp('/admin/patient/reservation/preparecreate', { patientId, service })

export const create = (reservation) =>
  invokeHttp('admin/patient/reservation/create', {
    patientId: reservation.patientId,
    address: reservation.address,
    addressLatLng: reservation.addressLatLng,
    hospital: reservation.hospital,
    hospitalLatLng: reservation.hospitalLatLng,
    note: reservation.note,
    caregiverNote: reservation.caregiverNote,
    requireCaregiverTypes: reservation.requireCaregiverTypes,
    workType: reservation.workType,
    shift: reservation.shift,
    dates: reservation.dates,
    discount: reservation.price.discount,
    promotionCode: reservation.promotionCode,
    package: reservation.package,
    fake: reservation.fake,
    daysOff: reservation.daysOff,
    service: reservation.service,
  })

export const prepareupdate = (id) =>
  invokeHttp('/admin/patient/reservation/prepareupdate', { id })

export const update = (reservation) =>
  invokeHttp('/admin/patient/reservation/update', reservation)

export const remove = (id) =>
  invokeHttp('/admin/patient/reservation/delete', { id })

export const get = (id) =>
  invokeHttp('/admin/patient/reservation/get', { id })

export const price = (reservation) =>
  invokeHttp('/admin/patient/reservation/price', reservation)

export const calculate = (price) =>
  invokeHttp('/admin/patient/reservation/calculate', price)

export const promotions = (patientId, shifts, selectedPackage) =>
  invokeHttp('/admin/patient/reservation/promotions', { patientId, shifts, selectedPackage })

export const calculateDates = (pck, startDate, daysOff) =>
  invokeHttp('/admin/patient/reservation/calculateDates', {
    package: pck,
    startDate: startDate,
    daysOff: daysOff,
  })

export const cancelNextBill = (id, reason) =>
  invokeHttp('/admin/patient/reservation/cancelnextbill', { id, reason })

export const preparecancel = (id) =>
  invokeHttp('/admin/patient/reservation/preparecancel', { id })

export const calculaterefund = (id, dates, chargePercent) =>
  invokeHttp('/admin/patient/reservation/calculaterefund', { id, dates, chargePercent })

export const cancel = (id, dates, reason, refund, chargePercent) =>
  invokeHttp('/admin/patient/reservation/cancel', { id, dates, reason, refund, chargePercent })

export const cancelpartial = (id, dates, reason, refund, chargePercent) =>
  invokeHttp('/admin/patient/reservation/cancelpartial', { id, dates, reason, refund, chargePercent })

export const cancelContinue = (id) =>
  invokeHttp('/admin/patient/reservation/cancelcontinue', { id })

export const markPaid = (id) =>
  invokeHttp('/admin/patient/reservation/markpaid', { id })

export const history = (id) =>
  invokeHttp('/admin/patient/reservation/history', { id })

export const historyList = (id) =>
  invokeHttp('/admin/patient/reservation/historylist', { id })

export const setSubscribe = (id, subscribe, reason) =>
  invokeHttp('/admin/patient/reservation/setsubscribe', { id, subscribe, reason })

export const editcard = (id) =>
  invokeHttp('/admin/patient/reservation/sendflexeditcreditcard', { id })

export const preparenextstartdate = (id) =>
  invokeHttp('/admin/patient/reservation/preparenextstartdate', { id })

export const nextstartdate = (id, nextStartDate) =>
  invokeHttp('/admin/patient/reservation/nextstartdate', { id, nextStartDate })

export const validatenextstartdate = (id, nextStartDate) =>
  invokeHttp('/admin/patient/reservation/validatenextstartdate', { id, nextStartDate })

export const validateupdate = (id, dates) =>
  invokeHttp('/admin/patient/reservation/validateupdate', { id, dates })
